import React from 'react';
import PropTypes from 'prop-types';

const ArrowNext = ({ color = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={color}
      fillRule="evenodd"
      d="m14.343 5.293 6.364 6.364a1 1 0 0 1 0 1.414l-6.364 6.364a1 1 0 1 1-1.414-1.414l4.657-4.657H4a1 1 0 0 1 0-2h13.586l-4.657-4.657a1 1 0 0 1 1.414-1.414Z"
      clipRule="evenodd"
    />
  </svg>
);

ArrowNext.propTypes = {
  color: PropTypes.string
};

export default ArrowNext;
